import {ListTable} from "../component/ListTable";
import {useContext, useEffect, useState} from "react";
import {Context} from "../component/context";
import {Get} from "component/const/Get";
import {filter} from "component/const/Functions";
import {getUserId} from "component/const/ForAuth";

export const TestApp = () =>{
    const {search} = useContext(Context);
    const [test, setTest] = useState(null)
    const [data, setData] = useState(null)
    useEffect(()=>{
        getUserId()
            .then(data=>{Get(`rpc/list_test?p_user_id=${data}`)
                .then(res=>setTest(res))})
    },[])

    useEffect(() => {
        setData(filter(test, search))
    }, [test, search]);

    return <ListTable data={data}/>
}
